/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import NotificationAlert from "react-notification-alert";
import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
import ChipInput from "material-ui-chip-input";
import * as Utils from "./Utils";

// reactstrap components
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  CardLink,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import classnames from "classnames";

import { connect } from "react-redux";
// import CommentsBlock from "simple-react-comments";
import { arrayOf } from "prop-types";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import logo from '../assets/img/ziro.png'

function UserView(props) {
  //first, set profile info hooks
  const [profilePic, setProfilePic] = React.useState(logo);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [tagline, setTagline] = React.useState("");
  const [userDescription, setUserDescription] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [zip, setZip] = React.useState(0);
  const [email, setEmail] = React.useState("");
  const [title, setTitle] = React.useState("");

  //next, set hook for if user is same as profile or not
  const [isUser, setIsUser] = React.useState(false);

  //next, set hooks for user project info
  const [programs, setPrograms] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [programTitle, setProgramTitle] = React.useState("");
  const [programDesc, setProgramDesc] = React.useState("");
  //Used to set the type of project
  const [programType, setProgramType] = React.useState(false);
  const [tags, setTags] = React.useState([]);

  //finally, hooks for user lists
  const [lists, setLists] = React.useState([]);
  const [userLists, setUserLists] = React.useState([]);
  const [modalList, setModalList] = React.useState(false);
  const [listTitle, setListTitle] = React.useState("");
  const [listDescription, setListDescription] = React.useState("");
  const [starred, setStarred] = React.useState([]);

  const [checkedState, setCheckedState] = React.useState(
    new Array(userLists.length).fill(false)
  );
  const [checkboxModal, setCheckboxModal] = React.useState(false);
  //hook for spinner animations
  const [loading, setLoading] = React.useState(true);
  const [loadingUser, setLoadingUser] = React.useState(true);
  const notificationAlertRef = React.useRef(null);
  const location = useLocation();
  const oldLocation = usePrevious(location);
  const log = localStorage.getItem("loggedin");

  //useEffect hook to properly reload when clicking on a different user-view page
  useEffect(() => {
    // console.log("old", oldLocation);
    // console.log("new", location);
    if(oldLocation){
      if(oldLocation.search !== location.search || oldLocation.pathname !== location.pathname){
        window.location.reload();
      }
    }
  }, [location])

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  
  useEffect(() => {
    setCheckedState(new Array(Object.keys(lists).length).fill(false));
  }, [userLists]);

  //other hooks
  const [activeTab, setActiveTab] = React.useState("1"); //hook for updating set of tabs
  const [projectID, setProjectID] = React.useState("");

  useEffect(() => {
    fetchProfile();
    fetchProjects();
    fetchLists();
    fetchUserLists();
    fetchStarred();
  }, [props.userID]);


  //profile methods
  function fetchProfile(){
    var desiredUser = new URLSearchParams(props.location.search).get("uid");
    if (desiredUser === null) {
      desiredUser = props.userID;
    }
    if(desiredUser){
      Utils.getProfile(desiredUser, profileCallback);
      if (
        new URLSearchParams(props.location.search).get("uid") === null ||
        desiredUser === props.userID
      ) {
        setIsUser(true);
      } else {
        setIsUser(false);
      }
    }
  }

  function profileCallback(res){
    if(res){
      setFirstName(res.first_name);
      setLastName(res.last_name);
      setUserDescription(res.description);
      setUsername(res.username);
      setCity(res.city);
      setState(res.state);
      setCountry(res.country);
      setZip(res.zip);
      setTagline(res.tagline);
      setEmail(res.email);
      setProfilePic(res.img_url.img_url);
    }
  }

  useEffect(() => {
    if(firstName !== ""){
      setLoadingUser(false);
    }
  }, [firstName])

  //project methods
  function fetchProjects(){
    var desiredUser = new URLSearchParams(props.location.search).get("uid");
    if (desiredUser === null) {
      desiredUser = props.userID;
    }
    if(desiredUser){
      Utils.getProjects(desiredUser, projectCallback);
    }
  }

  function projectCallback(res){
    if(res){
      setPrograms(res);
      setLoading(false);
    }
  }

  useEffect(() => {
    if(programs.length > 0){
      setLoading(false);
    }
  }, [programs])

  //list methods
  function fetchLists() { //plural fetch lists. the 'lists' hooks should be an array of the user's created lists, all with their own info, args should only be auth/id token/userID
    var desiredUser = new URLSearchParams(props.location.search).get("uid");
    if (desiredUser === null) {
      desiredUser = props.userID;
    }
    if(desiredUser){
      Utils.getLists(desiredUser, listCallback);
    }
  }

  function listCallback(res){
    if(res){
      setLists(res);
      
    }
  }

  function fetchUserLists(){ //fetching the lists of the user viewing the page
    var id_token = Utils.getCookie("ziroatoken");
    if(id_token){
      Utils.getUserLists(id_token, userListCallback)
    }
  }

  function userListCallback(res){
    if(res){
      setUserLists(res);
    }
  }

  //starred methods
  function fetchStarred() {
    var desiredUser = new URLSearchParams(props.location.search).get("uid");
    if (desiredUser === null) {
      desiredUser = props.userID;
    }
    if(desiredUser){
      Utils.getStarred(desiredUser, starredCallback);
    }
  }

  function starredCallback(res){
    if(res){
      setStarred(res);
    }
  }
  
  //Handles setting the project type
  function handleChange() {
    setProgramType(!programType);
  }

  function createProject(title, description, blockly) {
    var id_token = Utils.getCookie("ziroatoken");
    if (title.length > 50 || description.length > 250) {
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/createproject?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      Utils.notify("Project created successfully.", notificationAlertRef);
      toggleModal();
      fetchProjects();
    };

    xhr.send(
      JSON.stringify({
        title: title,
        description: description,
        robotics_tag: tags.includes("robotics"),
        coding_tag: tags.includes("coding"),
        physics_tag: tags.includes("physics"),
        other_tags: tags,
        // Blockly property sent
        blockly: blockly,
      })
    );
  }

  function deleteProject(fileID) {
    var id_token = Utils.getCookie("ziroatoken");
    if (window.confirm("Are you sure you want to delete this project?")) {
      var xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "https://zirostudio.appspot.com/deleteproject?authtoken=" + id_token
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function () {
        Utils.notify(
          "Deleted project successfully.",
          notificationAlertRef
        );
        fetchProjects();
      };

      xhr.send(JSON.stringify({ file_id: fileID }));
    } else {
      // Do nothing!
    }
  }
  
  //list creation
  function createList(title, description) {
    var id_token = Utils.getCookie("ziroatoken");
    if (title.length > 50 || description.length > 250) {
      return;
    }
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/createplaylist?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      toggleModalList();
      fetchLists();
    };

    xhr.send(JSON.stringify({ title: title, description: description }));
  }

  //list deletion
  function deleteList(listID) {
    if (window.confirm("Are you sure you want to delete this list?")) {
      var id_token = Utils.getCookie("ziroatoken");

      var xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "https://zirostudio.appspot.com/deleteplaylist?authtoken=" + id_token
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function () {
        fetchLists();
      };
      xhr.send(JSON.stringify({ playlist_id: listID }));
    } else {
      //nothing here!
    }
  }

  function toggleModal() {
    setModal(!modal);
  }

  //toggle list modal
  function toggleModalList() {
    setModalList(!modalList);
  }

  function toggleCheckboxModal() {
    setCheckboxModal(!checkboxModal);
  } 

  //TODO: modify backend to handle adding one project to multiple lists
  function addProjectToPlaylist(checkedState, projID) {
    //loop through checkedState to see which ones were selected
    if(!projID){
      return;
    }
    let playlistIds = [];

    for (let i = 0; i < checkedState.length; i++) {
      if (checkedState[i] === true) {
        playlistIds.push(lists[i].playlist_id);
      }
    }

    if (playlistIds.length > 0) {
      for (let i = 0; i < playlistIds.length; i++) {
        var id_token = Utils.getCookie("ziroatoken");
        var xhr = new XMLHttpRequest();
        xhr.open(
          "POST",
          "https://zirostudio.appspot.com/editplaylist?authtoken=" + id_token
        );
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          Utils.notify(
            "Added project to list(s) successfully.",
            notificationAlertRef
          );
          toggleCheckboxModal();
        };

        xhr.send(
          JSON.stringify({
            playlist_id: playlistIds[i],
            file_id: projID,
            operation: true,
          })
        );
      }
    }
    playlistIds = [];
  }

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
  };

  //toggle for project + list + starred tabs
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  function addToPlaylist(fileID, blockly) {
    var id_token = Utils.getCookie("ziroatoken");
    Utils.addPlaylist(id_token, fileID, userLists, addToPlayListCallback);
    setProjectID(fileID);
  }

  function addToPlayListCallback(res){
    setCheckedState(res);
    toggleCheckboxModal();
  }

  return (
    <>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      {log === "false" && props.location.search === "" && (
        <Redirect to="/explore"/>
      )}
      <div className="content">
        <Card className="card-header">
          <Row>
            <div className="author" style={{ marginLeft: 15 }}>
              <a href="#pablo" onClick={(e) => e.preventDefault()}>
                <img alt="..." className="avatar" src={profilePic} />
              </a>
            </div>
            <Col sm="6" style={{ marginLeft: 10 }}>
              {programs.length === 0 && loadingUser  ? (
                <Row>
                  <Col>
                    <Spinner
                      animation="border"
                      color="info"
                      style={{
                        padding: 0,
                        margin: 7,
                        marginLeft: 15,
                      }}
                    />
                  </Col>
                </Row>
              )
              : null}
              <h3 style={{ marginBottom: 0 }}>{firstName + " " + lastName}</h3>
              <h4 style={{ marginBottom: 0 }}>{username}</h4>
              <h4 style={{ marginBottom: 0 }}>{email}</h4>
              <h4 style={{ marginBottom: 0 }}>
                {Utils.renderNames(city, state, country)}
              </h4>
              <h4 style={{ marginBottom: 0 }}>{tagline}</h4>
            </Col>
          </Row>
        </Card>
        <Row>
          <Col md={12}>
            <Card
              className="card-tasks"
              style={{ height: "100%", paddingTop: 10 }}
            >
              <CardBody>
                <Row>
                  <Col>
                    <Nav tabs style={{ borderColor: "white" }}>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => {
                            toggle("1");
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#ffffff",
                            backgroundColor: "transparent",
                            borderBottomColor: "#ffffff",
                          }}
                        >
                          {" "}
                          <h3 style={{ marginBottom: 0 }}>Projects</h3>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => {
                            toggle("2");
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#ffffff",
                            backgroundColor: "transparent",
                            borderBottomColor: "#ffffff",
                          }}
                        >
                          <h3 style={{ marginBottom: 0 }}>Lists</h3>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => {
                            toggle("3");
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#ffffff",
                            backgroundColor: "transparent",
                            borderBottomColor: "#ffffff",
                          }}
                        >
                          <h3 style={{ marginBottom: 0 }}>Starred</h3>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    {isUser ? (
                      <Button
                        className="btn-simple btn btn-info float-right"
                        onClick={toggleModal}
                        style={
                          ({ padding: 10 }, { marginTop: -50, marginRight: 0 })
                        }
                      >
                        <i
                          className="fa fa-plus"
                          style={{
                            marginRight: 8,
                            color: "#1e7ddb",
                            fontSize: "1.1em",
                          }}
                        />
                        New Project
                      </Button>
                    ) : null}
                    <br></br>
                    <UncontrolledDropdown>
                      <Modal
                        isOpen={modal}
                        toggle={toggleModal}
                        style={{ paddingBottom: 10 }}
                        backdropClassName={"modal-dark"}
                      >
                        <div className="modal-header">
                          <h3 className="modal-title" id="exampleModalLabel">
                            Create Project
                          </h3>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={toggleModal}
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </button>
                        </div>
                        <ModalBody>
                          <FormGroup
                            className={title.length <= 50 ? "" : "has-danger"}
                          >
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                Project Name
                              </h4>
                            </Label>
                            <Input
                              type="email"
                              name="email"
                              id="projName"
                              placeholder="Title"
                              onChange={(txt) =>
                                setProgramTitle(txt.target.value)
                              }
                            ></Input>
                            <p
                              style={{
                                fontSize: "smaller",
                                alignContent: "right",
                                color: programTitle.length <= 50 ? "" : "red",
                              }}
                              className="float-right"
                            >
                              {programTitle.length + "/50"}
                            </p>
                          </FormGroup>
                          <FormGroup
                            className={
                              programDesc.length <= 250 ? "" : "has-danger"
                            }
                          >
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                Project Description
                              </h4>
                            </Label>
                            <Input
                              type="text"
                              name="error"
                              id="projDescription"
                              placeholder="Description"
                              onChange={(txt) =>
                                setProgramDesc(txt.target.value)
                              }
                            />
                            <p
                              style={{
                                fontSize: "smaller",
                                alignContent: "right",
                                color: programDesc.length <= 250 ? "" : "red",
                              }}
                              className="float-right"
                            >
                              {programDesc.length + "/250"}
                            </p>
                          </FormGroup>
                          <FormGroup>
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                Tags
                              </h4>
                              <Badge color="success">physics</Badge>
                              <Badge color="warning">coding</Badge>
                              <Badge color="danger">robotics</Badge>
                              <Badge color="info">custom</Badge>
                            </Label>
                            <ChipInput
                              onChange={(chips) =>
                                setTags(
                                  chips.map((chip) => {
                                    return chip.toLowerCase();
                                  })
                                )
                              }
                              variant="outlined"
                              chipRenderer={Utils.renderChip}
                              classes={{
                                inputRoot: "input-chip-tags-root",
                                input: "input-chip-tags-input",
                              }}
                              style={{ width: "100%" }}
                              dataSource={[
                                "physics",
                                "math",
                                "coding",
                                "robotics",
                              ]}
                              newChipKeyCodes={[13, 188]}
                              placeholder={"Enter comma-separated tags"}
                            ></ChipInput>
                            {/*<div className={classes.root}>
                          <Autocomplete
                            multiple
                            id="tags-standard"
                            options={["physics", "coding", "robotics"]}
                            getOptionLabel={(option) => option}
                            defaultValue={[]}
                            renderTags={(value, getTagProps) =>
                              value.map((tag, index) => (
                                <Badge color="primary">{tag}</Badge>
                              ))
                            }
                          />
                        </div>
                        {/*
                          <Autosuggest>
                            suggestions={["work", "please"]}
                            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onSuggestionsClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            inputProps={{
                              value: props, // usually comes from the application state
                              onChange: onChange, // called every time the input value changes
                            }}
                          </Autosuggest>*/}
                          </FormGroup>
                          <FormGroup check disabled>
                            <h4 style={{ color: "black", marginBottom: 0 }}>
                              Visibility
                            </h4>
                            <Label check>
                              <Input type="checkbox" disabled /> Public
                              <span className="form-check-sign">
                                <span className="check"></span>
                              </span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <h4 style={{ color: "black", marginBottom: 0 }}>
                              Project Type
                            </h4>
                            <Label check>
                              <Input type="checkbox" 
                               checked={programType} 
                               style = {{marginBottom: 0}}
                               onChange={() => handleChange()}/> Block (Default Code)
                              <span className="form-check-sign">
                                <span className="check"></span>
                              </span>
                            </Label>
                          </FormGroup>
                          <FormGroup>
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                Thumbnail
                              </h4>
                              To capture a thumbnail, go to Studio and press the{" "}
                              <i className="fas fa-camera" /> icon.
                            </Label>
                          </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            className="animation-on-hover"
                            color="success"
                            style={{ marginLeft: 24, marginBottom: 16 }}
                            onClick={() =>
                              createProject(programTitle, programDesc, programType)
                            }
                          >
                            Create
                          </Button>

                          {/*
                      <Button color="secondary" onClick={toggleModal} style={{"marginLeft": 24, "marginBottom": 20}}>
                          Close
                      </Button>
                      <Button color="primary" style={{"marginRight": 24, "marginBottom": 20}}>
                          Save changes
                      </Button>
                      <Button color="primary">
                          Save changes
                      </Button>
                      <Button color="primary">
                          Save changes
                      </Button>*/}
                        </ModalFooter>
                      </Modal>
                    </UncontrolledDropdown>

                    <CardBody>
                        {programs.length === 0 && loading ? (
                          <Row>
                            <Col>
                              <Spinner
                                animation="border"
                                color="info"
                                style={{
                                  padding: 0,
                                  margin: 7,
                                  marginLeft: 15,
                                }}
                              />
                            </Col>
                          </Row>
                        )
                        : null}
                        {programs.length === 0 && !loading ? (
                          <Row>
                            <Col>
                              <h3>This user does not have any projects.</h3>
                            </Col>
                          </Row>
                        )
                        : null}
                      <Row>
                        {programs.map((item) => {
                          return (
                            <Col md={4} style={{ marginBottom: 20 }}>
                              <Card className="" style={{ height: "100%" }}>
                                <Link
                                  to={{
                                    pathname:
                                      "/studio?code=" +
                                      item["file_id"],
                                  }}
                                  target="_blank"
                                >
                                  <img
                                    className="img-fluid"
                                    onError={Utils.addDefaultSrc}
                                    alt="Ziro Studio Thumbnail"
                                    src={
                                      "https://storage.googleapis.com/user-thumbnails/" +
                                      item["file_id"] + ".jpg"
                                    }
                                  ></img>
                                </Link>

                                <Row style={{ marginTop: -45, marginLeft: -7 }}>
                                  <Col>
                                    <Link
                                      to={{
                                        pathname:
                                          "/studio?code=" + item["file_id"],
                                      }}
                                      target="_blank"
                                    >
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                        }}
                                        id={"toStudio" + item["file_id"]}
                                      >
                                        <i
                                          className="tim-icons icon-double-right"
                                          color="white"
                                        />
                                      </Button>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={"toStudio" + item["file_id"]}
                                        style={{ pointerEvents: "none" }}
                                      >
                                        Proceed to Studio
                                      </UncontrolledTooltip>
                                    </Link>

                                    <Link
                                      to={
                                          "/project-info?id=" + item["file_id"]
                                      }
                                      key={props.location.key}
                                    >
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                        }}
                                        id={"moreInfo" + item["file_id"]}
                                      >
                                        <i className="fa fa-info" />
                                      </Button>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={"moreInfo" + item["file_id"]}
                                        style={{ pointerEvents: "none" }}
                                      >
                                        More Information
                                      </UncontrolledTooltip>
                                    </Link>
                                    <div
                                      style={{
                                        fontSize: "larger",
                                        marginTop: 0,
                                        marginRight: 5,
                                        color: "#208cfc",
                                        float: "right",
                                        transform: "translate(0px, 20px)",
                                      }}
                                      >
                                        <p
                                          className="fas fa-star"
                                          style={{ marginRight: 3, color: "#208cfc" }}
                                        ></p>
                                        {item["num_star"]}
                                    </div>
                                    
                                    {props.auth === 1 ? (
                                      <>
                                        <Button
                                          className="btn-round btn-icon btn-clear"
                                          style={{
                                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                                            backgroundImage: "",
                                          }}
                                          id={"playlista" + item["file_id"]}
                                          onClick={() => {
                                            addToPlaylist(item["file_id"], item["blockly"]);
                                          }}
                                        >
                                          <i className="fas fa-plus" />
                                        </Button>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={"playlista" + item["file_id"]}
                                          style={{ pointerEvents: "none" }}
                                        >
                                          Add to List
                                        </UncontrolledTooltip>
                                      </>
                                    ) : null}
                                    {isUser ? (
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                        }}
                                        onClick={() => {
                                          deleteProject(item["file_id"]);
                                        }}
                                      >
                                        <i className="fa fa-trash" />
                                      </Button>
                                      
                                    ) : (
                                      <></>
                                    )}
                                    {/* Block flag for project cards */}
                                    <div
                                      style = {{
                                        display: item["blockly"] ? "inline-block" : "none",
                                      }}
                                      
                                      >
                                        <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                          
                                        }}
                                        id = {"BC" + item["fileID"]}
                                      >
                                       <p> <i
                                          class="fa-solid fa-b"
                                          
                                        /> {item["blockly"] ? "B" : ""}
                                      </p></Button>
                                        
                                    </div>


                                    <Modal
                                      isOpen={checkboxModal}
                                      toggle={toggleCheckboxModal}
                                      style={{ paddingBottom: 10 }}
                                      backdropClassName={"modal-dark"}
                                      size="sm"
                                    >
                                      <ModalHeader>
                                        <h4
                                          className="modal-title"
                                          id="exampleModalLabel"
                                          style={{marginBottom: 0}}
                                        >
                                          Save to...
                                        </h4>
                                        <button
                                          type="button"
                                          className="close"
                                          data-dismiss="modal"
                                          aria-hidden="true"
                                          onClick={toggleCheckboxModal}
                                        >
                                          <i className="tim-icons icon-simple-remove" />
                                        </button>
                                      </ModalHeader>
                                      {userLists.length === 0 && props.auth === 1 ? (
                                        <Row>
                                          <Col>
                                          <p style={{color: "#000", marginLeft: 25, marginTop: 15}}>
                                            You don't have any lists. Create a list 
                                            <a href="/user-view"> here!</a>
                                          </p>
                                          </Col>
                                        </Row>
                                      )
                                      : null}
                                      {userLists.map((key, index) => {
                                        return (
                                          <>
                                            <ModalBody
                                              style={{
                                                padding: 5,
                                                paddingLeft: 20,
                                                paddingBottom: -10,
                                              }}
                                            >
                                              <FormGroup check>
                                                <Label
                                                  check
                                                  htmlFor={`custom-checkbox-${index}`}
                                                >
                                                  {/* Checkbox for setting code or block project */}
                                                  <Input
                                                    type="checkbox"
                                                    id={`custom-checkbox-${index}`}
                                                    name={key.title}
                                                    value={key.title}
                                                    checked={
                                                      checkedState[index]
                                                    }
                                                    onChange={() =>
                                                      handleOnChange(index)
                                                    }
                                                  />
                                                  {key.title}
                                                  <span className="form-check-sign">
                                                    <span className="check"></span>
                                                  </span>
                                                </Label>
                                              </FormGroup>
                                            </ModalBody>
                                          </>
                                        );
                                      })}

                                      <ModalFooter>
                                        {userLists.length === 0 ? (
                                          <Button
                                          color="success"
                                          className="animation-on-hover"
                                          style={{
                                            marginLeft: 24,
                                            marginBottom: 16,
                                            marginTop: 15,
                                          }}
                                          disabled
                                        >
                                          Add to List
                                        </Button>
                                        )
                                        : <Button
                                          color="success"
                                          className="animation-on-hover"
                                          style={{
                                            marginLeft: 24,
                                            marginBottom: 16,
                                            marginTop: 15,
                                          }}
                                          onClick={() =>
                                            addProjectToPlaylist(
                                              checkedState,
                                              projectID
                                            )
                                          }
                                        >
                                          Add to List
                                        </Button>}
                                        
                                      </ModalFooter>
                                    </Modal>
                                  </Col>
                                </Row>

                                <CardBody>
                                  <CardText />
                                  <div className="author">
                                    <Link
                                      to={{
                                        pathname:
                                          "/studio?code=" +
                                          item["file_id"],
                                      }}
                                      target="_blank"
                                    >
                                      <h3 style={{ marginBottom: 0 }}>
                                        {item["title"]}
                                      </h3>
                                    </Link>
                                    <p
                                      className="description"
                                      style={Utils.descStyle}
                                    >
                                      {item["description"]}
                                    </p>
                                  </div>

                                  <div style={{ marginTop: 5 }}>
                                    {"physics_tag" in item &&
                                      item["physics_tag"] == true && (
                                        <Badge color="success">physics</Badge>
                                      )}
                                    {"coding_tag" in item &&
                                      item["coding_tag"] == true && (
                                        <Badge color="warning">coding</Badge>
                                      )}
                                    {"robotics_tag" in item &&
                                      item["robotics_tag"] == true && (
                                        <Badge color="danger">robotics</Badge>
                                      )}
                                    {"other_tags" in item &&
                                      item["other_tags"].map(
                                        (tag) =>
                                          tag != "physics" &&
                                          tag != "coding" &&
                                          tag != "robotics" && (
                                            <Badge color="info">{tag}</Badge>
                                          )
                                      )}
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </TabPane>

                  <TabPane tabId="2">
                    {isUser ? (
                      <Button
                        className="btn-simple float-right"
                        color="info"
                        onClick={toggleModalList}
                        style={
                          ({ padding: 10 }, { marginTop: -50, marginRight: 0 })
                        }
                      >
                        <i
                          className="fa fa-plus"
                          style={{
                            marginRight: 8,
                            color: "#1e7ddb",
                            fontSize: "1.1em",
                          }}
                        />{" "}
                        New List
                      </Button>
                    ) : null}
                    <br></br>

                    <UncontrolledDropdown>
                      <Modal
                        isOpen={modalList}
                        toggle={toggleModalList}
                        style={{ paddingBottom: 10 }}
                        backdropClassName={"modal-dark"}
                      >
                        <div className="modal-header">
                          <h3 className="modal-title" id="exampleModalLabel">
                            Create List
                          </h3>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            onClick={toggleModalList}
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </button>
                        </div>
                        <ModalBody>
                          <FormGroup
                            className={
                              listTitle.length <= 50 ? "" : "has-danger"
                            }
                          >
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                List Name
                              </h4>
                            </Label>
                            <Input
                              type="email"
                              id="projName"
                              placeholder="Title"
                              onChange={(txt) => setListTitle(txt.target.value)}
                            ></Input>
                            <p
                              style={{
                                fontSize: "smaller",
                                alignContent: "right",
                                color: listTitle.length <= 50 ? "" : "red",
                              }}
                              className="float-right"
                            >
                              {listTitle.length + "/50"}
                            </p>
                          </FormGroup>
                          <FormGroup
                            className={
                              listDescription.length <= 250 ? "" : "has-danger"
                            }
                          >
                            <Label for="exampleEmail">
                              <h4 style={{ color: "black", marginBottom: 0 }}>
                                List Description
                              </h4>
                            </Label>
                            <Input
                              type="text"
                              name="error"
                              id="projDescription"
                              placeholder="Description"
                              onChange={(txt) =>
                                setListDescription(txt.target.value)
                              }
                            />
                            <p
                              style={{
                                fontSize: "smaller",
                                alignContent: "right",
                                color:
                                  listDescription.length <= 250 ? "" : "red",
                              }}
                              className="float-right"
                            >
                              {listDescription.length + "/250"}
                            </p>
                          </FormGroup>
                          <FormGroup check>
                            <Label check>
                              <Input type="checkbox" /> Private
                              <span className="form-check-sign">
                                <span className="check"></span>
                              </span>
                            </Label>
                          </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            className="animation-on-hover"
                            color="success"
                            style={{ marginLeft: 24, marginBottom: 16 }}
                            onClick={() =>
                              createList(listTitle, listDescription)
                            }
                          >
                            Create
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </UncontrolledDropdown>

                    <CardBody>
                      {lists.length === 0 && !loading ? (
                          <Row>
                            <Col>
                              <h3>This user does not have any lists.</h3>
                            </Col>
                          </Row>
                        )
                        : null}
                      <Row>
                        {lists.map((listItem, listIndex) => {
                          return (
                            <Col md={4} style={{ marginBottom: 20 }}>
                              <Card className="" style={{ height: "100%" }}>
                                <Link
                                  to={
                                      "/list-view?id=" +
                                      listItem["playlist_id"]
                                  }
                                >
                                  <img
                                    className="img-fluid"
                                    onError={Utils.addDefaultSrc}
                                    src={
                                      "https://storage.googleapis.com/user-thumbnails/" +
                                      listItem['project_list'].split(",")[0] + ".jpg"
                                    }
                                  ></img>
                                </Link>
                                <Row style={{ marginTop: -45, marginLeft: -7 }}>
                                  <Col md={12}>
                                    {isUser ? (
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                          marginBottom: 0
                                        }}
                                        onClick={() => {
                                          deleteList(listItem["playlist_id"]);
                                        }}
                                      >
                                        <i className="fa fa-trash" />
                                      </Button>
                                    ) : (
                                      <>
                                      <br></br>
                                      <br></br>
                                      </>
                                    )}
                                  </Col>
                                </Row>
                                <CardBody>
                                  <CardText />
                                  <Link
                                    to={
                                        "/list-view?id=" +
                                        listItem["playlist_id"]
                                    }
                                  >
                                    <h3 style={{ marginBottom: 0 }}>
                                      {listItem["title"]}
                                    </h3>
                                  </Link>
                                  <p className="description" style={Utils.descStyle}>
                                    {listItem["description"]}
                                  </p>
                                  <Link
                                    to={
                                        "/list-view?id=" +
                                        listItem["playlist_id"]
                                    }
                                  >
                                    <a style={{ marginTop: -20 }}>
                                      VIEW FULL LIST
                                    </a>
                                  </Link>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </TabPane>
                  <TabPane tabId="3">
                    <br></br>
                    <CardBody>
                      {starred.length === 0 ? (
                          <Row>
                            <Col>
                              <h3>This user does not have any starred projects.</h3>
                            </Col>
                          </Row>
                        )
                        : null}
                      <Row>
                        {starred.map((starItem, starIndex) => {
                          return (
                            <Col md={4} style={{ marginBottom: 20 }}>
                              <Card className="" style={{ height: "100%", marginBottom: 0 }}>
                                <Link
                                  to={{
                                    pathname:
                                      "/studio?code=" +
                                      starItem["proj_details"][0]["file_id"],
                                  }}
                                  target="_blank"
                                >
                                  <img
                                    className="img-fluid"
                                    onError={Utils.addDefaultSrc}
                                    src={
                                      "https://storage.googleapis.com/user-thumbnails/" +
                                      starItem["proj_details"][0]["file_id"] + ".jpg"
                                    }
                                  ></img>
                                </Link>

                                <Row style={{ marginTop: -45, marginLeft: -7 }}>
                                  <Col>
                                    <Link
                                      to={{
                                        pathname:
                                          "/studio?code=" + starItem["proj_details"][0]["file_id"],
                                      }}
                                      target="_blank"
                                    >
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                                          backgroundImage: "",
                                        }}
                                        id={"toStudio" + starItem["proj_details"][0]["file_id"]}
                                      >
                                        <i
                                          className="tim-icons icon-double-right"
                                          color="white"
                                        />
                                      </Button>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={"toStudio" + starItem["proj_details"][0]["file_id"]}
                                        style={{ pointerEvents: "none" }}
                                      >
                                        Proceed to Studio
                                      </UncontrolledTooltip>
                                    </Link>

                                    <Link
                                      to={
                                          "/project-info?id=" + starItem["proj_details"][0]["file_id"]
                                      }
                                    >
                                      <Button
                                        className="btn-round btn-icon btn-clear"
                                        style={{
                                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                                          backgroundImage: "",
                                        }}
                                        id={"moreInfo" + starItem["proj_details"][0]["file_id"]}
                                      >
                                        <i className="fa fa-info" />
                                      </Button>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={"moreInfo" + starItem["proj_details"][0]["file_id"]}
                                        style={{ pointerEvents: "none" }}
                                      >
                                        More Information
                                      </UncontrolledTooltip>
                                    </Link>
                                  </Col>
                                </Row>

                                <CardBody>
                                  <CardText />
                                  <div className="author">
                                    <Link
                                      to={{
                                        pathname:
                                          "/studio?code=" +
                                          starItem["proj_details"][0]["file_id"],
                                      }}
                                      target="_blank"
                                    >
                                      <h3 style={{ marginBottom: 0 }}>
                                        {starItem["proj_details"][0]["title"]}
                                      </h3>
                                    </Link>
                                    <p className="description" style={Utils.descStyle}>
                                      {starItem["proj_details"][0]["description"]}
                                    </p>
                                  </div>

                                  <div style={{ marginTop: 5 }}>
                                    {
                                      starItem["proj_details"][0]["physics_tag"] == true && (
                                        <Badge color="success">physics</Badge>
                                      )}
                                    {
                                      starItem["proj_details"][0]["coding_tag"] == true && (
                                        <Badge color="warning">coding</Badge>
                                      )}
                                    {
                                      starItem["proj_details"][0]["robotics_tag"] == true && (
                                        <Badge color="danger">robotics</Badge>
                                      )}
                                  </div>
                                <Link to={"/user-view?uid=" + starItem["proj_details"][0]['user_id']} key={props.location.key}>
                                  <Row style={{ marginTop: 15 }}>
                                    <div
                                      className="author"
                                      style={{ marginLeft: 15 }}
                                    >
                                      <a
                                        href="#"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <img
                                          alt="..."
                                          className="avatar"
                                          src={starItem["proj_details"][0]["img_url"]}
                                        />
                                      </a>
                                    </div>
                                    <a
                                      className="description"
                                      style={{
                                        fontSize: "1rem",
                                        marginLeft: 10,
                                        marginTop: 3,
                                      }}
                                    >
                                      {true
                                        ? starItem["proj_details"][0]["first_name"] +
                                          " " +
                                          starItem["proj_details"][0]["last_name"]
                                        : ""}
                                    </a>
                                  </Row>
                              </Link>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </TabPane>
                </TabContent>
                {/* </Row> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  userID: state.userID,
});

export default connect(mapStateToProps)(UserView);
